import { createContext, useContext } from "react";

/**
 * Clever solution to avoid a common and frustrating limitation with React
 * Contexts -- needing to define nonsense default values
 * https://medium.com/@rivoltafilippo/typing-react-context-to-avoid-an-undefined-default-value-2c7c5a7d5947
 */
export const createGenericContext = <ContextProps,>(name: string) => {
  // Create a context with a generic parameter or undefined
  const GenericContext = createContext<ContextProps | undefined>(undefined);

  // Check if the value provided to the context is defined or throw an error
  const useGenericContext = <SpecificContextProps = ContextProps,>() => {
    const contextIsDefined = useContext(GenericContext) as SpecificContextProps;
    if (!contextIsDefined) {
      throw new Error(`${name}: useGenericContext() must be used within a Provider`);
    }
    return contextIsDefined;
  };

  return [useGenericContext, GenericContext] as const;
};
